/** Approved Additional Charges copy — informational only; not added to fares. Do not paraphrase. */
const ADDITIONAL_CHARGES_TITLE = 'Additional Charges';

const ADDITIONAL_CHARGES_LINE =
  'Tolls / Inter-State Permit / Parking / Pet Charges / Hill Station Charges / Luggage Carrier Charges / Extra Drop Charges';

const ADDITIONAL_CHARGES_NOTE =
  'The following charges are not included in the displayed fare and will be charged extra, where applicable.';

/** Shown on fare/results for both One Way Drop and Round Trip. */
const shouldShowAdditionalChargesNotice = (tripType) =>
  tripType === 'One Way' || tripType === 'Round Trip';

module.exports = {
  ADDITIONAL_CHARGES_TITLE,
  ADDITIONAL_CHARGES_LINE,
  ADDITIONAL_CHARGES_NOTE,
  shouldShowAdditionalChargesNotice,
};
